<template>
  <div class="home">
    <Header></Header>
    <div class="section">
      <div class="mainTop">
        <div class="underHeader">
          <img src="../../assets/img/info.png" alt />
          当前位置：
        </div>
        <el-breadcrumb
          separator-class="el-icon-arrow-right"
          style="width:50%;height: 54px;display: inline-block;line-height: 54px;"
        >
          <el-breadcrumb-item :to="{ path: '/' }">平台首页</el-breadcrumb-item>
          <el-breadcrumb-item>检索结果</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="mainBottom">
        <div class="mainBottom_left">
          <div class="mainBotton_top">
            <el-header style="text-align: right; font-size: 12px;height:auto;;margin-bottom:23px;">
              <el-form id="r_form_box">
                <el-form-item
                  label="登记状态"
                  size="medium"
                  style="margin-bottom:0;border: 1px solid #08396A;"
                >
                  <el-radio-group
                    v-model="params.managementForms"
                    @change="iptChange('managementForms')"
                    size="medium"
                    style="float:left;display:flex;align-items:center;height:36px;"
                  >
                    <el-radio
                      :label="v.orderNum"
                      v-for="(v,i) in management_forms"
                      :key="i"
                    >{{v.showName}}</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  label="成立时间"
                  size="medium"
                  style="margin-bottom:0;border: 1px solid #08396A; "
                >
                  <el-radio-group
                    v-model="registrationDateRange"
                    @change="iptChange('registrationDateRange')"
                    size="medium"
                    style="float:left;display:flex;align-items:center;height:36px;"
                  >
                    <el-radio
                      :label="v.showName"
                      v-for="(v,i) in ageLimitData"
                      :key="i"
                    >{{v.showName}}</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  label="注册资本"
                  size="medium"
                  style="margin-bottom:0;border: 1px solid #08396A;border-top: none;border-bottom: none; border-right: 1px solid #08396A;    color: #fff;"
                >
                  <el-radio-group
                    v-model="registered_capital"
                    @change="iptChange('registered_capital')"
                    size="medium"
                    style="float:left;display:flex;align-items:center;height:36px;"
                  >
                    <el-radio
                      :label="v.showName"
                      v-for="(v,i) in capitalData"
                      :key="i"
                    >{{v.showName}}</el-radio>
                  </el-radio-group>
                </el-form-item>
                <div class="caseaderBox">
                  <el-form-item
                    label="所属行业"
                    size="medium"
                    style="margin-bottom:0; border-right: 1px solid #08396A;"
                  >
                    <el-cascader
                      ref="industry"
                      collapse-tags
                      v-model="params.industry_id"
                      :options="industryData"
                      :props="industry_props"
                      :show-all-levels="false"
                      :placeholder="params.industry_name"
                      @change="iptChange('industry_id')"
                    ></el-cascader>
                  </el-form-item>
                  <el-form-item
                    label="登记城市"
                    size="medium"
                    style="margin-bottom:0;border: 1px solid #08396A;margin-left:200px;border-top:0;border-bottom:0;"
                  >
                    <el-cascader
                      ref="city"
                      collapse-tags
                      v-model="params.region_id"
                      :options="region"
                      :show-all-levels="false"
                      :props="city_props"
                      :placeholder="params.region_name"
                      @change="iptChange('region_id')"
                    ></el-cascader>
                  </el-form-item>
                </div>
                <!-- <el-form-item
                  label="其他条件"
                  size="medium"
                  style="margin-bottom:0;border: 1px solid #08396A;"
                  class="label_140"
                >
                  <div style="display:flex;">
                    <el-select
                      v-model="params.invite"
                      placeholder="用工招聘"
                      @change="iptChange('invite')"
                    >
                      <el-option
                        v-for="item in inviteData"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        size="mini"
                      ></el-option>
                    </el-select>
                    <el-select
                      v-model="params.tendering"
                      placeholder="招标投标"
                      @change="iptChange('tendering')"
                    >
                      <el-option
                        v-for="item in tenderingData"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        size="mini"
                      ></el-option>
                    </el-select>
                    <el-select
                      v-model="params.ratepayer"
                      placeholder="一般纳税人"
                      @change="iptChange('ratepayer')"
                    >
                      <el-option
                        v-for="item in ratepayerData"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        size="mini"
                      ></el-option>
                    </el-select>
                    <el-select
                      v-model="params.patent"
                      placeholder="专利信息"
                      @change="iptChange('patent')"
                    >
                      <el-option
                        v-for="item in patentData"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        size="mini"
                      ></el-option>
                    </el-select>
                    <el-select
                      v-model="params.brand"
                      placeholder="商标信息"
                      @change="iptChange('brand')"
                    >
                      <el-option
                        v-for="item in brandData"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        size="mini"
                      ></el-option>
                    </el-select>
                    <el-select
                      v-model="params.copyright"
                      placeholder="作品著作权"
                      @change="iptChange('copyright')"
                    >
                      <el-option
                        v-for="item in copyrightData"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        size="mini"
                      ></el-option>
                    </el-select>
                  </div>
                  <div style="display:flex;">
                    <el-select
                      v-model="params.history"
                      placeholder="历史变更"
                      @change="iptChange('history')"
                    >
                      <el-option
                        v-for="item in historyData"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        size="mini"
                      ></el-option>
                    </el-select>
                    <el-select
                      v-model="params.promise"
                      placeholder="失信信息"
                      @change="iptChange('promise')"
                    >
                      <el-option
                        v-for="item in promiseData"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        size="mini"
                      ></el-option>
                    </el-select>
                    <el-select
                      v-model="params.judgment"
                      placeholder="裁判文书"
                      @change="iptChange('judgment')"
                    >
                      <el-option
                        v-for="item in judgmentData"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        size="mini"
                      ></el-option>
                    </el-select>
                    <el-select
                      v-model="params.court"
                      placeholder="法院公告"
                      @change="iptChange('court')"
                    >
                      <el-option
                        v-for="item in courtData"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        size="mini"
                      ></el-option>
                    </el-select>
                    <el-select
                      v-model="params.punish"
                      placeholder="行政处罚"
                      @change="iptChange('punish')"
                    >
                      <el-option
                        v-for="item in punishData"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        size="mini"
                      ></el-option>
                    </el-select>
                    <el-select
                      v-model="params.abnormal "
                      placeholder="经营异常"
                      @change="iptChange('abnormal')"
                    >
                      <el-option
                        v-for="item in abnormalData"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        size="mini"
                      ></el-option>
                    </el-select>
                  </div>
                  <div style="display:flex;">
                    <el-select
                      v-model="params.capital_type_id"
                      placeholder="资本类型"
                      @change="iptChange('capital_type_id')"
                    >
                      <el-option
                        v-for="item in capital_type"
                        :key="item.value"
                        :label="item.showName"
                        :value="item.orderNum"
                        size="mini"
                      ></el-option>
                    </el-select>
                    <el-select
                      v-model="params.company_type_id"
                      placeholder="企业类型"
                      @change="iptChange('company_type_id')"
                    >
                      <el-option
                        v-for="item in company_type"
                        :key="item.value"
                        :label="item.showName"
                        :value="item.orderNum"
                        size="mini"
                      ></el-option>
                    </el-select>
                    <el-select
                      v-model="params.organization_id"
                      placeholder="组织机构"
                      @change="iptChange('organization_id')"
                    >
                      <el-option
                        v-for="item in organization"
                        :key="item.value"
                        :label="item.showName"
                        :value="item.orderNum"
                        size="mini"
                      ></el-option>
                    </el-select>
                    <el-select v-model="social" placeholder="参保人数" @change="iptChange('social')">
                      <el-option
                        v-for="item in socialData"
                        :key="item.value"
                        :label="item.showName"
                        :value="item.showName"
                        size="mini"
                      ></el-option>
                    </el-select>
                    <el-select
                      v-model="params.financing"
                      placeholder="融资信息"
                      @change="iptChange('financing')"
                    >
                      <el-option
                        v-for="item in financing"
                        :key="item.value"
                        :label="item.showName"
                        :value="item.orderNum"
                        size="mini"
                      ></el-option>
                    </el-select>
                    <el-select
                      v-model="params.list_type_id "
                      placeholder="上市状态"
                      @change="iptChange('list_type_id')"
                    >
                      <el-option
                        v-for="item in list_type"
                        :key="item.value"
                        :label="item.showName"
                        :value="item.orderNum"
                        size="mini"
                      ></el-option>
                    </el-select>
                  </div>
                </el-form-item>-->
                <el-form-item
                  label="已选条件"
                  size="medium"
                  style="margin-bottom:0;border: 1px solid #08396A;"
                  class="label_50"
                >
                  <el-tag
                    v-for="(item,i) in items"
                    :key="i"
                    size="medium"
                    :closable="item.label == '全部'? false : true"
                    style="float:left; color:#fff;border-radius:0;margin:2.5px;"
                    effect="dark"
                    @close="closeTags(item)"
                    v-if="item.showType&&item.label!=''&&item.label!=undefined"
                  >{{ item.value}}：{{item.label }}</el-tag>
                </el-form-item>
              </el-form>
            </el-header>
          </div>
          <div class="mainBottom_bottom">
            <div class="mainbottom_bottom_header">
              <p>
                国研网按条件共为您找到
                <span
                  style="color:#FF4021;font-size:18px;"
                >{{totlalCount==1000?totlalCount+'+':totlalCount}}</span> 家企业
              </p>
              <div class="header_right">
                <!-- <el-select
                  v-model="params.order"
                  placeholder="成立日期 从最近到过去"
                  @change="iptChange('order')"
                >
                  <el-option
                    v-for="item in orderData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    size="mini"
                    style="height:32px;line-height:32px;"
                  ></el-option>
                </el-select>-->
                <el-button type="primary" size="mini" @click="downCompanyData" title="支持1000条">数据导出</el-button>
              </div>
            </div>
            <div class="mainbottom_bottom_center">
              <div class="centerBox" v-for="(v,i) in centerBoxData" :key="i">
                <h3 @click="goEnterprisesDetail(v)" v-html="v.companyName"></h3>
                <div class="centerBox_btm">
                  <div>
                    <!-- <p>上市市场：深圳证券交易所</p> -->
                    <p></p>
                    <p>成立日期：{{v.registration_date}}</p>
                    <p style="margin-left:20px;">注册资本：{{v.registered_capital}}万元</p>
                    <!-- <p class="mt19">上市日期：未上市</p> -->
                  </div>
                  <div>
                    <!-- <p class="mt19">上市市场：无</p> -->
                    <p class="mt19">注册地址：{{v.business_address}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="rightPaging">
            <el-pagination
              prev-text="上一页"
              next-text="下一页"
              background
              @current-change="handleCurrentChange"
              :current-page="params.pageNo"
              :page-size="params.pageSize"
              layout="total, prev, pager, next, jumper"
              :total="totlalCount>100?100:totlalCount"
            ></el-pagination>
          </div>
        </div>
        <div class="mainBottom_right">
          <div class="company_right">
            <div v-for="(item,key) in hitsList" :key="key" class="companyBox">
              <h3 @click="goEnterprisesDetail(item)">{{item.companyName}}</h3>
              <!-- <div class="btnBoxs">
                <button class="bt1">国企</button>
                <button class="bt2">上市企业</button>
              </div>-->
            </div>
          </div>
          <div class="advertisingBox">
            <img src="../../assets/img/gg1.png" alt />
            <img src="../../assets/img/gg2.png" alt style="margin-left:5px;" />
          </div>
          <div class="advertisingBox2">
            <img src="../../assets/img/gg3.png" alt />
            <p>
              <span>随时随地</span>
              <span>就在国研网企业app</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from "@/components/header";
import Footer from "@/components/footer";
import LeftNav from "@/components/leftNav";
import api from "@/../static/common/api/api.js";
import axios from "axios";
import magic from "@/../static/common/magic.js";
export default {
  props: {},
  components: {
    Header,
    Footer,
    LeftNav
  },
  data() {
    let _self = this;
    return {
      params: {
        // order: 1,
        pageNo: 1,
        pageSize: 10
      },
      centerBoxData: [], //列表数据
      hitsList: [], //点击率排行列表
      totlalCount: 0, //总条数
      management_forms: [], //高级查询登记状态
      industryData: [], //所属行业数据-第一级
      industryData2: [], //所属行业数据-二三级
      region: [], // 所在城市数据
      region2: [], // 所在城市数据二三级
      company_type: [], //企业类型
      capital_type: [], //资本类型
      list_type: [], //上市情况
      organization: [], //组织机构
      financing: [], //融资信息
      registrationDateRange: "", //年限
      registered_capital: "", //资本
      social: "", //社保
      items: [
        {
          // label: "全部",
          type: "managementForms",
          value: "登记状态",
          showType: false
        },
        {
          // label: "全部",
          type: "registrationDateRange",
          value: "成立时间",
          showType: false
        },
        {
          // label: "全部",
          type: "registered_capital",
          value: "注册资本",
          showType: false
        },
        {
          label: "",
          type: "companyName",
          value: "关键字",
          showType: false
        },
        { label: "", type: "industry_id", value: "所属行业", showType: false },
        { label: "", type: "region_id", value: "登记城市", showType: false },

        { label: "", type: "invite", value: "用工招聘", showType: false },
        { label: "", type: "tendering", value: "招标投标", showType: false },
        { label: "", type: "ratepayer", value: "一般纳税人", showType: false },
        { label: "", type: "patent", value: "专利信息", showType: false },
        { label: "", type: "brand", value: "商标信息", showType: false },
        { label: "", type: "copyright", value: "作品著作权", showType: false },
        { label: "", type: "history", value: "历史变更", showType: false },
        { label: "", type: "promise", value: "失信信息", showType: false },
        { label: "", type: "judgment", value: "裁判文书", showType: false },
        { label: "", type: "court", value: "法院公告", showType: false },
        { label: "", type: "punish", value: "行政处罚", showType: false },
        { label: "", type: "abnormal", value: "经营异常", showType: false },

        {
          label: "",
          type: "capital_type_id",
          value: "资本类型",
          showType: false
        },
        {
          label: "",
          type: "company_type_id",
          value: "企业类型",
          showType: false
        },
        {
          label: "",
          type: "organization_id",
          value: "组织机构",
          showType: false
        },
        { label: "", type: "social", value: "参保人数", showType: false },
        { label: "", type: "financing", value: "融资信息", showType: false },
        { label: "", type: "list_type_id", value: "上市状态", showType: false }
      ],
      orderData: [
        {
          label: "成立日期 从最近到过去",
          value: 1
        },
        {
          label: "成立日期 从过去到最近",
          value: 2
        }
      ],
      socialData: [
        //社保人数
        { orderNum: 1, showName: "1-10人" },
        { orderNum: 2, showName: "10-20人" },
        { orderNum: 3, showName: "20-100人" },
        { orderNum: 4, showName: "100-500人" },
        { orderNum: 5, showName: "500-1000人" },
        { orderNum: 6, showName: "1000人以上" }
      ],
      capitalData: [
        // 注册资本
        // { orderNum: 0, showName: "全部" },
        { orderNum: 1, showName: "0-100万" },
        { orderNum: 2, showName: "100-500万" },
        { orderNum: 3, showName: "500-1000万" },
        { orderNum: 4, showName: "1000-3000万" },
        { orderNum: 5, showName: "3000-5000万" },
        { orderNum: 6, showName: "5000万以上" }
      ],

      ageLimitData: [
        //成立年限
        // { orderNum: 0, showName: "全部" },
        { orderNum: 1, showName: "0-1年" },
        { orderNum: 2, showName: "1-3年" },
        { orderNum: 3, showName: "3-5年" },
        { orderNum: 4, showName: "5-10年" },
        { orderNum: 5, showName: "10-15年" },
        { orderNum: 6, showName: "10年以上" }
      ],
      industry_props: {
        //所属行业props配置
        // lazy: true,
        multiple: true,
        value: "industry_id",
        label: "industry_name",
        children: "childrenList"
        // lazyLoad(node, resolve) {
        //   const level = node.level;
        //   const id = node.value;
        //   api.imap_getNextIndustryDot(id).then(res => {
        //     let _industry = res.data;
        //     let node = _self.changeBool(_self, _industry, "leaf");
        //     for (let i = 0; i < _industry.length; i++) {
        //       _self.industryData2.push(_industry[i]);
        //     }
        //     resolve(_industry);
        //   });
        // }
      },
      city_props: {
        //登记城市props配置
        // lazy: true,
        multiple: true,
        children: "childrenList",
        value: "region_id",
        label: "regin_name"
        // lazyLoad(node, resolve) {
        //   const level = node.level;
        //   const id = node.value;
        //   api.getNextRegionData(id).then(res => {
        //     let _region = res.data;
        //     let node = _self.changeBool(_self, _region, "leaf");
        //     for (let i = 0; i < _region.length; i++) {
        //       _self.region2.push(_region[i]);
        //     }
        //     resolve(_region);
        //   });
        // }
      },
      inviteData: [
        //用工招聘
        {
          value: 0,
          label: "有用工招聘"
        },
        {
          value: 1,
          label: "无用工招聘"
        }
      ],
      tenderingData: [
        //招标投标
        {
          value: 0,
          label: "有招标投标"
        },
        {
          value: 1,
          label: "无招标投标"
        }
      ],
      ratepayerData: [
        //纳税
        {
          value: 0,
          label: "是一般纳税人"
        },
        {
          value: 1,
          label: "其他纳税人"
        }
      ],
      patentData: [
        //专利
        {
          value: 0,
          label: "有专利信息"
        },
        {
          value: 1,
          label: "无专利信息"
        }
      ],
      brandData: [
        //品牌
        {
          value: 0,
          label: "有品牌信息"
        },
        {
          value: 1,
          label: "无品牌信息"
        }
      ],
      copyrightData: [
        //作品著作权
        {
          value: 0,
          label: "有著作权"
        },
        {
          value: 1,
          label: "无著作权"
        }
      ],
      historyData: [
        //历史变更
        {
          value: 0,
          label: "有历史变更"
        },
        {
          value: 1,
          label: "无历史变更"
        }
      ],
      promiseData: [
        //失信信息
        {
          value: 0,
          label: "有失信信息"
        },
        {
          value: 1,
          label: "无失信信息"
        }
      ],
      judgmentData: [
        //裁判文书
        {
          value: 0,
          label: "有裁判文书"
        },
        {
          value: 1,
          label: "无裁判文书"
        }
      ],
      courtData: [
        //法院公告
        {
          value: 0,
          label: "有法院公告"
        },
        {
          value: 1,
          label: "无法院公告"
        }
      ],
      punishData: [
        //行政处罚
        {
          value: 0,
          label: "有行政处罚"
        },
        {
          value: 1,
          label: "无行政处罚"
        }
      ],
      abnormalData: [
        //经营异常
        {
          value: 0,
          label: "有经营异常"
        },
        {
          value: 1,
          label: "无经营异常"
        }
      ]
    };
  },
  computed: {},
  methods: {
    //获取检索条件
    getSearchData() {
      let _this = this;
      api.getSearchData().then(res => {
        _this.management_forms = [
          // { orderNum: 0, showName: "全部" },
          ...res.data.management_forms
        ];
        _this.company_type = res.data.company_type;
        _this.capital_type = res.data.capital_type;
        _this.list_type = res.data.list_type;
        _this.organization = res.data.organization;
        _this.financing = res.data.financing;
        // _this.industryData = _this.changeBool(_this, res.data.industry, "leaf");
        _this.industryData = res.data.industry;
        // _this.region = _this.changeBool(_this, res.data.region, "leaf");
        _this.region = res.data.region;
        setTimeout(() => {
          $("#r_form_box .el-form-item__content .el-radio-button__inner").css({
            border: "none",
            "border-radius": "0"
          }); //去掉form表单的border；
          $("#r_form_box .el-form-item__label").css({
            width: "140px",
            color: "#fff;",
            "font-weight": "400",
            "font-size": "14px",
            "text-align": "left",
            "border-width": "1px",
            "border-style": "solid",
            "border-color": "#08396A",
            "border-top": "0",
            "border-left": "0",
            "border-bottom": "0",
            "padding-left": "20px"
          });
        }, 0);
        // 已选条件
        _this.items.forEach((v, i) => {
          if (v.type == "managementForms") {
            _this.management_forms.forEach(cap => {
              if (cap.orderNum == v.label) {
                v.label = cap.showName;
              }
            });
          } else if (v.type == "registrationDateRange") {
            return;
          } else if (v.type == "registered_capital") {
            return;
          } else if (v.type == "social") {
            return;
          } else if (v.type == "capital_type_id") {
            _this.capital_type.forEach(cap => {
              if (cap.orderNum == v.label) {
                v.label = cap.showName;
              }
            });
          } else if (v.type == "company_type_id") {
            _this.company_type.forEach(cap => {
              if (cap.orderNum == v.label) {
                v.label = cap.showName;
              }
            });
          } else if (v.type == "organization_id") {
            _this.organization.forEach(cap => {
              if (cap.orderNum == v.label) {
                v.label = cap.showName;
              }
            });
          } else if (v.type == "financing") {
            _this.financing.forEach(cap => {
              if (cap.orderNum == v.label) {
                v.label = cap.showName;
              }
            });
          } else if (v.type == "list_type_id") {
            _this.list_type.forEach(cap => {
              if (cap.orderNum == v.label) {
                v.label = cap.showName;
              }
            });
          } else if (v.type == "industry_id") {
            v.label = _this.$route.params.industry_name;
          } else if (v.type == "region_id") {
            v.label = _this.$route.params.region_name;
          } else if (v.type == "invite") {
            _this.inviteData.forEach(cap => {
              if (cap.value == v.label) {
                v.label = cap.label;
              }
            });
          } else if (v.type == "tendering") {
            _this.tenderingData.forEach(cap => {
              if (cap.value == v.label) {
                v.label = cap.label;
              }
            });
          } else if (v.type == "ratepayer") {
            _this.ratepayerData.forEach(cap => {
              if (cap.value == v.label) {
                v.label = cap.label;
              }
            });
          } else if (v.type == "patent") {
            _this.patentData.forEach(cap => {
              if (cap.value == v.label) {
                v.label = cap.label;
              }
            });
          } else if (v.type == "brand") {
            _this.brandData.forEach(cap => {
              if (cap.value == v.label) {
                v.label = cap.label;
              }
            });
          } else if (v.type == "copyright") {
            _this.copyrightData.forEach(cap => {
              if (cap.value == v.label) {
                v.label = cap.label;
              }
            });
          } else if (v.type == "history") {
            _this.historyData.forEach(cap => {
              if (cap.value == v.label) {
                v.label = cap.label;
              }
            });
          } else if (v.type == "promise") {
            _this.promiseData.forEach(cap => {
              if (cap.value == v.label) {
                v.label = cap.label;
              }
            });
          } else if (v.type == "judgment") {
            _this.judgmentData.forEach(cap => {
              if (cap.value == v.label) {
                v.label = cap.label;
              }
            });
          } else if (v.type == "court") {
            _this.courtData.forEach(cap => {
              if (cap.value == v.label) {
                v.label = cap.label;
              }
            });
          } else if (v.type == "punish") {
            _this.punishData.forEach(cap => {
              if (cap.value == v.label) {
                v.label = cap.label;
              }
            });
          } else if (v.type == "abnormal") {
            _this.abnormalData.forEach(cap => {
              if (cap.value == v.label) {
                v.label = cap.label;
              }
            });
          }
        });
      });
    },
    //获取列表
    getCompanyData(params) {
      if (this.registrationDateRange) {
        // 成立时间特殊处理
        this.params["registrationDateRange"] =
          this.registrationDateRange == "全部"
            ? ""
            : this.registrationDateRange.substring(
                this.registrationDateRange.length - 3
              ) == "年以上"
            ? this.registrationDateRange.substring(
                0,
                this.registrationDateRange.length - 3
              ) + ":100"
            : this.registrationDateRange
                .substring(0, this.registrationDateRange.length - 1)
                .split("-")
                .join(":");
      }
      if (this.registered_capital) {
        //注册资本特殊处理
        this.params["registered_capital"] =
          this.registered_capital == "全部"
            ? ""
            : this.registered_capital.substring(
                this.registered_capital.length - 3
              ) == "万以上"
            ? this.registered_capital.substring(
                0,
                this.registered_capital.length - 3
              ) + ":200000000000"
            : this.registered_capital
                .substring(0, this.registered_capital.length - 1)
                .split("-")
                .join(":");
      }
      if (this.social) {
        //参保人数特殊处理
        this.params["social"] =
          this.social == "全部"
            ? ""
            : this.social.substring(this.social.length - 3) == "人以上"
            ? this.social.substring(0, this.social.length - 3) + ":1000000"
            : this.social
                .substring(0, this.social.length - 1)
                .split("-")
                .join(":");
      }
      api.getCompanyData(params).then(res => {
        this.centerBoxData = res.data.data;
        this.totlalCount = res.data.totlalCount;
      });
    },
    //将leaf里的字符串类型转成bool类型
    changeBool(_this, arr, val) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].childrenList.length) {
          _this.changeBool(arr[i].childrenList, val);
        } else {
          if (arr[i].hasOwnProperty(val)) {
            arr[i][val] = arr[i][val] == "false" ? "" : true;
          }
        }
      }
      return arr;
    },
    //下一页
    handleCurrentChange(val) {
      this.$set(this.params, "pageNo", val);
      this.getCompanyData(this.params);
    },
    //所有 input select 改变事件
    iptChange(val) {
      this.$set(this.params, "pageNo", 1);
      this.items.forEach((v, i) => {
        if (v.type == "managementForms" && v.type == val) {
          this.management_forms.forEach(cap => {
            if (cap.orderNum == this.params[v.type]) {
              v.label = cap.showName;
            }
          });
          v.showType = true;
        } else if (v.type == "registrationDateRange" && v.type == val) {
          v.label = this.registrationDateRange;
          v.showType = true;
        } else if (v.type == "registered_capital" && v.type == val) {
          v.label = this.registered_capital;
          v.showType = true;
        } else if (v.type == "social" && v.type == val) {
          v.label = this.social;
          if (v.label != "") {
            v.showType = true;
          }
        } else if (v.type == "capital_type_id" && v.type == val) {
          this.capital_type.forEach(cap => {
            if (cap.orderNum == this.params[v.type]) {
              v.label = cap.showName;
              v.showType = true;
            }
          });
        } else if (v.type == "company_type_id" && v.type == val) {
          this.company_type.forEach(cap => {
            if (cap.orderNum == this.params[v.type]) {
              v.label = cap.showName;
              v.showType = true;
            }
          });
        } else if (v.type == "organization_id" && v.type == val) {
          this.organization.forEach(cap => {
            if (cap.orderNum == this.params[v.type]) {
              v.label = cap.showName;
              v.showType = true;
            }
          });
        } else if (v.type == "financing" && v.type == val) {
          this.financing.forEach(cap => {
            if (cap.orderNum == this.params[v.type]) {
              v.label = cap.showName;
              v.showType = true;
            }
          });
        } else if (v.type == "list_type_id" && v.type == val) {
          this.list_type.forEach(cap => {
            if (cap.orderNum == this.params[v.type]) {
              v.label = cap.showName;
              v.showType = true;
            }
          });
        } else if (v.type == "industry_id" && v.type == val) {
          if (!this.$refs["industry"].getCheckedNodes()[0]) {
            v.showType = false;
          }
          v.label =
            this.$refs["industry"].getCheckedNodes().length > 0
              ? this.$refs["industry"].getCheckedNodes()[0].label + "..."
              : "";
          v.showType = true;
          this.params["industry_id"] = this.params["industry_id"].join(",");
        } else if (v.type == "region_id" && v.type == val) {
          if (!this.$refs["city"].getCheckedNodes()[0]) {
            v.showType = false;
          }
          v.label =
            this.$refs["city"].getCheckedNodes().length > 0
              ? this.$refs["city"].getCheckedNodes()[0].label + "..."
              : "";

          this.params["region_id"] = this.params["region_id"].join(",");
          v.showType = true;
        } else if (v.type == "invite" && v.type == val) {
          this.inviteData.forEach(cap => {
            if (cap.value == this.params[v.type]) {
              v.label = cap.label;
              v.showType = true;
            }
          });
        } else if (v.type == "tendering" && v.type == val) {
          this.tenderingData.forEach(cap => {
            if (cap.value == this.params[v.type]) {
              v.label = cap.label;
              v.showType = true;
            }
          });
        } else if (v.type == "ratepayer" && v.type == val) {
          this.ratepayerData.forEach(cap => {
            if (cap.value == this.params[v.type]) {
              v.label = cap.label;
              v.showType = true;
            }
          });
        } else if (v.type == "patent" && v.type == val) {
          this.patentData.forEach(cap => {
            if (cap.value == this.params[v.type]) {
              v.label = cap.label;
              v.showType = true;
            }
          });
        } else if (v.type == "brand" && v.type == val) {
          this.brandData.forEach(cap => {
            if (cap.value == this.params[v.type]) {
              v.label = cap.label;
              v.showType = true;
            }
          });
        } else if (v.type == "copyright" && v.type == val) {
          this.copyrightData.forEach(cap => {
            if (cap.value == this.params[v.type]) {
              v.label = cap.label;
              v.showType = true;
            }
          });
        } else if (v.type == "history" && v.type == val) {
          this.historyData.forEach(cap => {
            if (cap.value == this.params[v.type]) {
              v.label = cap.label;
              v.showType = true;
            }
          });
        } else if (v.type == "promise" && v.type == val) {
          this.promiseData.forEach(cap => {
            if (cap.value == this.params[v.type]) {
              v.label = cap.label;
              v.showType = true;
            }
          });
        } else if (v.type == "judgment" && v.type == val) {
          this.judgmentData.forEach(cap => {
            if (cap.value == this.params[v.type]) {
              v.label = cap.label;
              v.showType = true;
            }
          });
        } else if (v.type == "court" && v.type == val) {
          this.courtData.forEach(cap => {
            if (cap.value == this.params[v.type]) {
              v.label = cap.label;
              v.showType = true;
            }
          });
        } else if (v.type == "punish" && v.type == val) {
          this.punishData.forEach(cap => {
            if (cap.value == this.params[v.type]) {
              v.label = cap.label;
              v.showType = true;
            }
          });
        } else if (v.type == "abnormal" && v.type == val) {
          this.abnormalData.forEach(cap => {
            if (cap.value == this.params[v.type]) {
              v.label = cap.label;
              v.showType = true;
            }
          });
        }
      });
      if (this.items.findIndex(target => target.showType === true) == -1) {
        this.$message.error(
          "查询维度太宽泛,请缩小查询范围,默认展示前一千条结果!"
        );
        this.params.searchAll = 0;
      } else {
        this.params.searchAll = 1;
      }
      this.getCompanyData(this.params);
    },
    //删除已选标签
    closeTags(tag) {
      if (tag.type == "managementForms") {
        tag.label = "";
        this.params[tag.type] = 0;
        tag.showType = false;
      } else if (tag.type == "registrationDateRange") {
        tag.label = "";
        this.params[tag.type] = "";
        this.registrationDateRange = "";
        tag.showType = false;
      } else if (tag.type == "registered_capital") {
        tag.label = "";
        this.params[tag.type] = "";
        this.registered_capital = "";
        tag.showType = false;
      } else if (tag.type == "social") {
        this.social = "";
        this.params[tag.type] = "";
        tag.showType = false;
      } else if (tag.type == "industry_id") {
        this.params[tag.type] = "";
        this.params.industry_name = "请选择";
        tag.showType = false;
      } else if (tag.type == "region_id") {
        this.params[tag.type] = "";
        this.params.region_name = "请选择";
        tag.showType = false;
      } else {
        tag.showType = false;
        this.params[tag.type] = "";
      }
      if (this.items.findIndex(target => target.showType === true) == -1) {
        this.$message.error(
          "查询维度太宽泛,请缩小查询范围,默认展示前一千条结果!"
        );
        this.params.searchAll = 0;
      } else {
        this.params.searchAll = 1;
      }
      this.getCompanyData(this.params);
    },
    //跳转到企业画像
    goEnterprisesDetail(v) {
      if (v.organization_id == 2) {
        this.$router.push({
          path: "/enterprisesDetail2",
          query: { entId: v.entId }
        });
      } else {
        this.$router.push({
          path: "/enterprisesDetail",
          query: { entId: v.entId }
        });
      }
    },
    //导出当前数据
    downCompanyData() {
      magic.loginOrRights(1).then(res => {
        if (!res) {
          this.$message.error("请您登录！");
        } else {
          api.weighterRights(1).then(res => {
            if (res.data) {
              axios({
                method: "post",
                url: window.normalUrl + "/index/downCompanyData", // 请求地址
                data: this.params,
                responseType: "arraybuffer",
                observe: "response"
              }).then(res => {
                const fileName = "检索结果.xlsx";
                let blob = new Blob([res.data], {
                  type:
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                });
                if ("download" in document.createElement("a")) {
                  // 非IE下载
                  const elink = document.createElement("a");
                  elink.download = fileName;
                  elink.style.display = "none";
                  elink.href = URL.createObjectURL(blob);
                  document.body.appendChild(elink);
                  elink.click();
                  URL.revokeObjectURL(elink.href); // 释放URL 对象
                  document.body.removeChild(elink);
                } else {
                  // IE10+下载
                  navigator.msSaveBlob(blob, fileName);
                }
              });
            } else {
              this.$message.error("请您购买！");
            }
          });
        }
      });
    },
    getCompanyHits() {
      var size = 10;
      api.getCompanyHits(size).then(res => {
        this.hitsList = res.data;
      });
    }
  },
  created() {},
  mounted() {
    magic.loginOrRights(1).then(res => {
      if (!res) {
        this.$router.push("/login");
      }
    });
    if (!this.$route.params.managementForms) {
      //登记状态特殊处理
      this.params.managementForms = 0;
    }
    if (Object.keys(this.$route.params).length > 0) {
      // 路由信息特殊处理
      this.params = Object.assign(this.$route.params, this.params);
      for (let i in this.params) {
        if (
          typeof this.params[i] == "string" &&
          i != "region_id" &&
          i != "region_name" &&
          i != "industry_id" &&
          i != "industry_name" &&
          i != "companyName" &&
          i != "registrationDateRange" &&
          i != "registered_capital" &&
          i != "social"
        ) {
          this.params[i] = Number(this.params[i]); //装换number类型
        } else if (i == "region_id" || i == "industry_id") {
          if (this.params[i] instanceof Array) {
            // var arr;
            // this.params[i].forEach((v, i) => {
            //   arr.push(v[v.length - 1]);
            // });
            // this.params[i] = arr.join(",");
            // console.log(this.params[i]);
            // this.params[i] = this.params[i].pop();
          }
        } else if (i == "registrationDateRange") {
          if (this.params[i]) {
            this.registrationDateRange = this.params[i];
          } else {
            this.params[i] = "全部";
          }
        } else if (i == "registered_capital") {
          if (this.params[i]) {
            this.registered_capital = this.params[i];
          } else {
            this.params[i] = "全部";
          }
        } else if (i == "social") {
          this.social = this.params[i];
        }
        this.items.forEach((v, k) => {
          if (v.type == "industry_id") {
            v.label = this.params["industry_name"];
          }
          if (v.type == "region_id") {
            v.label = this.params["region_name"];
          }

          if (v.type == i) {
            if (i != "industry_id" || i != "region_id") {
              v.label = this.params[i];
              v.showType = true;
            }
          }
          if (v.type == "managementForms" && this.params[i] == 0) {
            v.showType = false;
          }
        });
      }
    }
    if (this.items.findIndex(target => target.showType === true) == -1) {
      this.$message.error(
        "查询维度太宽泛,请缩小查询范围,默认展示前一千条结果!"
      );
      this.params.searchAll = 0;
    } else {
      this.params.searchAll = 1;
    }
    this.getSearchData(); //获取检索条件
    this.getCompanyData(this.params); //获取列表
    this.getCompanyHits(); //获取推荐列表
  }
};
</script>
<style scoped lang="less">
.home {
  width: 100%;
  height: auto;
  background: url("../../assets/img/bg.png") no-repeat top;
}
.section {
  height: auto;
  padding: 0 20px;
  padding-bottom: 20px;
  box-sizing: border-box;
  .mainTop {
    display: flex;
    .underHeader {
      display: inline-block;
      height: 54px;
      line-height: 54px;
      padding-left: 19px;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #dfecf7;
      img {
        width: 12px;
        height: 16px;
      }
    }
    /deep/ .el-breadcrumb__inner {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #dfecf7;
    }
  }
  .mainBottom {
    width: 100%;
    display: flex;
    justify-content: space-between;
    height: auto;
    .mainBottom_left {
      width: 85%;
      display: flex;
      flex-direction: column;
      height: auto;
      .mainBotton_top {
        width: 100%;
        height: auto;
        .caseaderBox {
          border: 1px solid #08396a;
          border-bottom: none;
          display: flex;
          /deep/ .el-form-item__content {
            display: flex;
          }
          /deep/ .el-input__inner::placeholder {
            color: #fff;
          }
          /* 谷歌 */
          /deep/ .el-input__inner::-webkit-input-placeholder {
            color: #fff;
          }
          /* 火狐 */
          /deep/ .el-input__inner:-moz-placeholder {
            color: #fff;
          }
          /*ie*/
          /deep/ .el-input__inner:-ms-input-placeholder {
            color: #fff;
          }
        }
        .label_140 {
          /deep/.el-form-item__label {
            height: 140px !important;
            line-height: 140px !important;
            color: #fff;
          }
        }
        .label_50 {
          display: flex;
          align-items: center;
          /deep/.el-form-item__label {
            width: 139px !important;
            color: #fff;
            flex-shrink: 0;
            border-right: 0 !important;
          }
          /deep/.el-form-item__content {
            border-left: 1px solid #08396a;
            padding-left: 10px;
          }
        }
      }
      .mainBottom_bottom {
        border: 1px solid #08396a;
        margin-top: 25px;
        flex: 1;
        .mainbottom_bottom_header {
          height: 50px;
          background: rgba(5, 43, 79, 0.3);
          border-bottom: 1px solid #08396a;
          border-radius: 2px 2px 0px 0px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 10px 0 18px;
          box-sizing: border-box;
          p {
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #dfecf7;
          }
          .header_right {
            /deep/ .el-input__inner {
              height: 32px;
              line-height: 32px;
            }
            /deep/ .el-input__icon {
              line-height: 32px;
            }
          }
        }
        .mainbottom_bottom_center {
          display: flex;
          flex-direction: column;
          .centerBox {
            display: flex;
            flex-direction: column;
            margin-top: 32px;
            padding: 0 18px;
            box-sizing: border-box;
            h3 {
              font-size: 16px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #f1f8ff;
            }
            h3 /deep/ em {
              color: #177fe8 !important;
            }
            h3:hover {
              cursor: pointer;
              color: #177fe8;
            }
            .centerBox_btm {
              margin-top: 21px;
              display: flex;
              border-bottom: 1px solid #08396a;
              padding-bottom: 29px;
              flex-direction: column;
              .mt19 {
                margin-top: 19px;
              }
              p {
                font-size: 14px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #bac7d5;
              }
              div {
                display: flex;
              }
            }
          }
        }
      }
      .rightPaging {
        margin-top: 40px;
      }
    }
    .mainBottom_right {
      width: 240px;
      display: flex;
      flex-direction: column;
      height: auto;
      .company_right {
        background-color: rgba(5, 43, 79, 0.3);
        border: 1px solid #08396a;
        border-radius: 0px 0px 0px 2px;
        padding: 0 21px;
        box-sizing: border-box;
        margin-top: 21px;
        .companyBox {
          margin-top: 36px;
          padding-bottom: 27px;
          border-bottom: 1px solid #023261;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          align-items: start;
          h3 {
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #bac7d5;
            cursor: pointer;
          }
          .btnBoxs {
            margin-top: 14px;
            button {
              padding: 3px 5px;
              box-sizing: border-box;
              border: 0;
            }
            .bt1 {
              background: #3c98f5;
              border-radius: 2px;
              background-color: rgba(60, 152, 245, 0.2);
              font-size: 12px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #3c98f5;
            }
            .bt2 {
              background-color: rgba(247, 172, 42, 0.2);
              border-radius: 2px;
              font-size: 12px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #f7ac2a;
            }
          }
        }
      }
      .advertisingBox {
        margin-top: 22px;
        width: 240px;
        height: 233px;
        display: flex;
        padding: 18px 19px;
        justify-content: space-around;
        background: rgba(5, 43, 79, 0.3);
        border: 1px solid #08396a;
        border-radius: 0px 0px 0px 2px;
        box-sizing: border-box;
        img {
          width: 98px;
          height: 197px;
        }
      }
      .advertisingBox2 {
        margin-top: 22px;
        width: 240px;
        height: 108px;
        background: rgba(5, 43, 79, 0.3);
        border: 1px solid #08396a;
        border-radius: 0px 0px 0px 2px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        img {
          width: 65px;
          height: 65px;
        }
        p {
          display: flex;
          flex-direction: column;
          span {
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #bac7d5;
          }
        }
      }
    }
  }
  .el-cascader-panel {
    background: #023261 !important;

    border-radius: 2px !important;
  }
  .el-cascader__dropdown {
    border: 1px solid #0a67c4 !important;
  }
}

.title-img {
  width: 20px;
  height: 20px;
  font-size: 20px;
  left: 263px;
  top: 350px;
}
/deep/ .el-cascader {
  margin-left: 9px;
}
/deep/ .el-select {
  margin-left: 9px;
  margin-top: 7px;
}
/deep/ .el-radio-button__inner {
  background: none;
  color: #bac7d5;
}
/deep/ .el-input__inner {
  background: #023261;

  border: 1px solid #0a67c4;

  border-radius: 2px;
  color: #fff;
}
/deep/ .el-cascader-panel {
  background: #023261 !important;

  border-radius: 2px !important;
}
/deep/ .el-cascader__dropdown {
  border: 1px solid #0a67c4 !important;
}
/deep/ .popper__arrow {
  border-bottom-color: #0a67c4;
}
/deep/ .popper__arrow::after {
  border-bottom-color: #023261;
}
/deep/ .el-radio__input {
  display: none;
}
/deep/ .el-radio__label {
  color: #fff;
}
/deep/.el-form-item__label {
  color: #fff;
}
/deep/ .el-header {
  padding: 0;
}
</style>
 


// WEBPACK FOOTER //
// src/view/searchPage/index.vue